import { render, staticRenderFns } from "./confirm-document-dialog.vue?vue&type=template&id=2e7b8c42&scoped=true"
import script from "./confirm-document-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-document-dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm-document-dialog.vue?vue&type=style&index=0&id=2e7b8c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7b8c42",
  null
  
)

export default component.exports